import {Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {User} from '../../model/Entities/User';
import {Customer} from '../../model/Entities/Customer';
import {CustomerService} from '../../services/customer.service';
import {DialogService} from '../../services/dialog.service';
import {CustomerAresComparisonDialogComponent} from '../CustomerAresComparisonDialogComponent/customer-ares-comparison.dialog.component';

@Component({
    selector: 'customer-detail',
    templateUrl: './customer-detail.component.html',
    styleUrls: ['./customer-detail.component.scss']
})
export class CustomerDetailComponent implements OnInit {
    customer: Customer;
    constructor(private route: ActivatedRoute,
                private customerService: CustomerService,
                private dialogService: DialogService) {
    }

    ngOnInit(): void {
        const id = +this.route.snapshot.paramMap.get('id');
        this.customer = new Customer();
        // console.log('CUSTOMER', this.customer);

        this.loadCustomer(id);
    }

    private loadCustomer(id: Number): void {
        this.customerService.get(id, {expand: 'payment_type'}).subscribe((customer: Customer) => {
            this.customer = customer;
            // console.log(customer);
        });
    }

    searchAres(): void {
        this.dialogService.showDialog(CustomerAresComparisonDialogComponent, {
            customer: this.customer
        }, 800, 'auto').afterClosed().subscribe((updatedCustomer: Customer) => {
            if (updatedCustomer) {
                this.loadCustomer(this.customer.id);
            }
        });
    }
}



// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomerDetailComponent/customer-detail.component.ts